import * as constants from './config/constants.js';
import Selectors from './utils/selectors.js';
import jQuery from 'jquery';
import 'whatwg-fetch';
window.$ = window.jQuery = jQuery;
import ElementClassHandler from './utils/element-class-handler';

const selectors = new Selectors(),
    elementClassHandler = new ElementClassHandler;

export default class {

    constructor(options = {}) {
        this.options = options;
        this.employmentStatus = document.querySelector(options.employmentStatusFormElement);
        this.employmentStatusInputs = selectors.querySelectorArray('input', this.employmentStatus);
        this.employmentStatusEmployedInput = this.employmentStatus.querySelector('input[value="employed"]');
        const host = window.location.hostname;
        if (host.includes('carphonewarehouse')) {
            const width = window.innerWidth;
            if (width < 1024) {
                this.timeWithEmployerLabel = document.querySelector(options.timeWithEmployer + ' legend');
            } else {
                this.timeWithEmployerLabel = document.querySelector(options.timeWithEmployer + ' label');
            }
        }else if (host.includes('mobiles')) {
            const width = window.innerWidth;
            if (width < 1024) {
                this.timeWithEmployerLabel = document.querySelector(options.timeWithEmployer + ' legend');
            } else {
                this.timeWithEmployerLabel = document.querySelector(options.timeWithEmployer + ' label');
                this.timeWithEmployerLabel = document.querySelector('#form_employment_timeWithEmployer_row fieldset legend');
            }
        }else{
            this.timeWithEmployerLabel = document.querySelector(options.timeWithEmployer + ' label');
        }
        this.jobTitleSection = document.querySelector(options.jobTitleSection);
        this.jobTitleInput = this.jobTitleSection.querySelector('input');
    }

    setup() {
        const employmentStatusField = this.employmentStatus.querySelector('input:checked'),
            employmentStatus = employmentStatusField ? employmentStatusField.value : null;
        this.timeWithEmployerLabel.textContent = this.labelMapper(employmentStatus);
        this.toggleJobTitleSection();
        this.setupInputEventListener(this.employmentStatusInputs);

        fetch(constants.CHECKOUTPATH + '/ajax/job-titles.json')
            .then(response => response.json())
            .then((json) => {
                const source = this.substringMatcher(json);

                $('.typeahead').typeahead({
                    local: 'jobTitles',
                    hint: true,
                    highlight: true,
                    minLength: 1
                },
                {
                    name: 'jobTitles',
                    source: source
                });
            })
            .catch(function(err) {
                console.error('Fetch Error :-', err);
            });
    }

    substringMatcher(jobTitles) {
        return function findMatches(q, cb) {
            cb(jobTitles.filter(j => j.toLowerCase().includes(q.toLowerCase())));
        };
    }

    toggleJobTitleSection() {
        if (this.employmentStatusEmployedInput.checked) {
            elementClassHandler.show(this.jobTitleSection);
            this.jobTitleInput.setAttribute('required', 'required');
        } else {
            elementClassHandler.hide(this.jobTitleSection);
            this.jobTitleInput.removeAttribute('required');
        }
    }

    setupInputEventListener(inputs) {
        let self = this;
        inputs.forEach(function(element) {
            element.addEventListener('change', () => {
                const checkedValue = self.employmentStatus.querySelector('input:checked').value || null;
                self.toggleJobTitleSection();
                const host = window.location.hostname;
                if (host.includes('mobiles')) {
                    const width = window.innerWidth;
                    if (width < 1024) {
                        self.timeWithEmployerLabel = document.querySelector(self.options.timeWithEmployer + ' legend');
                    } else {
                        self.timeWithEmployerLabel = document.querySelector('#form_employment_timeWithEmployer_row fieldset legend');
                    }
                }else if (host.includes('carphonewarehouse')) {
                    const width = window.innerWidth;
                    if (width < 1024) {
                        self.timeWithEmployerLabel = document.querySelector(self.options.timeWithEmployer + ' legend');
                    } else {
                        self.timeWithEmployerLabel = document.querySelector(self.options.timeWithEmployer + ' label');
                    }
                }else{
                    self.timeWithEmployerLabel = document.querySelector(self.options.timeWithEmployer + ' label');
                }
                self.timeWithEmployerLabel.textContent = self.labelMapper(checkedValue);
            });
        });
    }

    labelMapper(employmentStatus) {
        if (employmentStatus === null || employmentStatus === 'employed') {
            return 'Time with employer?';
        }

        if (this.options.timeWithEmployerLabelMappings.hasOwnProperty(employmentStatus)) {
            return 'How many years have you been ' + this.options.timeWithEmployerLabelMappings[employmentStatus] + '?';
        }
        return 'How many years have you been ' + employmentStatus + '?';
    }
}
